module.exports = __webpack_public_path__ + "static/media/Down.a9d2f1fa.svg";